module.exports = __webpack_public_path__ + "img/zyncro-icon.c818e481.svg";